module.exports = __webpack_public_path__ + "static/media/eggplant.b44a3217.png";